import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/clients', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadTemplate(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/clients/template', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/clients/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, clientData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/clients', clientData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addBulk(ctx, clientData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/clients/upload', clientData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, clientData) {
      return new Promise((resolve, reject) => {
        const url = `/clients/${clientData.id}`
        axios
          .put(url, clientData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/clients/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
